export default {
    abi: [
        {
            "inputs": [
                {
                    "internalType": "string",
                    "name": "name",
                    "type": "string"
                },
                {
                    "internalType": "string",
                    "name": "symbol",
                    "type": "string"
                },
                {
                    "internalType": "uint256",
                    "name": "_totalPer",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "_amountPerAddress",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                }
            ],
            "name": "Approval",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "previousOwner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "OwnershipTransferred",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "from",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                }
            ],
            "name": "Transfer",
            "type": "event"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                }
            ],
            "name": "allowance",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "amountPerAddress",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "approve",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "balanceOf",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "claimTokens",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "creationBlock",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "creator",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "decimals",
            "outputs": [
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "subtractedValue",
                    "type": "uint256"
                }
            ],
            "name": "decreaseAllowance",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getContractDetails",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "_name",
                    "type": "string"
                },
                {
                    "internalType": "string",
                    "name": "_symbol",
                    "type": "string"
                },
                {
                    "internalType": "uint256",
                    "name": "_totalSupplyCap",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "_amountPerAddress",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "_remainingAddresses",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "_totalPer",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "_creationBlock",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "_creator",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_owner",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "addedValue",
                    "type": "uint256"
                }
            ],
            "name": "increaseAllowance",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "name",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "owner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "remainingAddresses",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "renounceOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "symbol",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalPer",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalSupply",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalSupplyCap",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transfer",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "from",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transferFrom",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "transferOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ] ,
    bytecode: "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"
}
